export default __webpack_public_path__ + "static/media/logo.f9a3fc87.png";